import BasePage from '../../components/base-page/base-page';
import DevelopersContactModal from '../../components/developers-contact-modal/developers-contact-modal';
import DevelopersContactForm from '../../components/developers-contact-form/developers-contact-form';

import './developers.scss';

class DevelopersPage extends BasePage {
  onInit() {
    super.onInit();

    this.developersModal = new DevelopersContactModal();
    this.developersModal.init();

    this.developersForm = new DevelopersContactForm({
      onSuccess: () => {
        this.developersModal.close();
      },
    });
    this.developersForm.init();
  }
}

export default DevelopersPage;

DevelopersPage.initOnDomLoaded();
